import { render, staticRenderFns } from "./LoginLog.vue?vue&type=template&id=f964e582"
import script from "./LoginLog.vue?vue&type=script&lang=ts"
export * from "./LoginLog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports